// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const GhostIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="GhostIcon" ref={forwardedRef} {...props}>
      <path d="M9 8v2H7.5V8z" />
      <path d="M12.5 10.008v-2H11v2z" />
      <path d="M13 16.944 14.5 18H16V8A6 6 0 0 0 4 8v10h1.5l1.393-1.056L8.5 18l1.5-1.056L11.5 18zm-1.5-.779L10 15.11l-1.53 1.077-1.64-1.078-1.33 1.01V8a4.5 4.5 0 0 1 9 0v8.165L13 15.11z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const GhostIcon = /* @__PURE__ */ Object.assign(GhostIconComponent, {
  displayName: 'GhostIcon',
});
